import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useUserManager } from '@/app/providers';

export const LOGOUT_ROUTE = '/authentication/logout';
export const LOGIN_ROUTE = '/authentication/login';
const AUTHENTICATION_ROUTE_PREFIX = '/authentication/';

type SignoutInteractionState = {
  interaction: 'signout';
};

export function createSignoutInteractionState(): SignoutInteractionState {
  return { interaction: 'signout' };
}

export function isSignoutInteractionState(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as SignoutInteractionState).interaction === 'signout'
  );
}

export function useNavigateToLogout(): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    void navigate(LOGOUT_ROUTE, { state: createSignoutInteractionState() });
  }, [navigate]);
}

export function useNavigateToReauthenticate(): () => void {
  const userManager = useUserManager();
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.pathname.startsWith(AUTHENTICATION_ROUTE_PREFIX)) {
      return;
    }

    const returnUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
    void userManager.removeUser().finally(() => {
      void navigate(LOGIN_ROUTE, { state: { returnUrl }, replace: true });
    });
  }, [userManager, navigate, location]);
}
